
import PreEntryApi from '../../assets/js/preentry'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

import { i18nHelper } from '@it-common/lbp_common'
import OnboardHeader from '../OnboardHeader'

export default {
components: {
Loading,
Group,
Cell,
XInput,
Search,
PopupRadio,
XButton,
Datetime,
Confirm,
OnboardHeader
},
data () {
return {
isZH: true,
id: '',
showsearch: false,
currentIndex: '',
eduList: [],
results: [],
value: '',
showLoading: true,
deleteRowsConfirm: false,
deleteCurIndex: '',
areaItems: [],
areaChangeItems: [],
areaChangeItemsEn: [],
mobileFlag: false,
country_id: '47206',
hasShowPopup: {
data: false
},
degree_index: 0,
minFirstWorkDate: { date: 1979 },
code: '',
educationItems: [],
studyStyleItems: [],
degreeItems: []
}
},
computed: {












isfirstItems: function () {
return [
{ key: 1, value: this.$tsg('是') },
{ key: 2, value: this.$tsg('否') }
]
}
































},
created () {
this.id = this.$route.query.id
this.mobileFlag = this.isMobile()
this.postPsOption()

var localStorage = window.localStorage
this.code = localStorage.getItem('pre_code')
this.isZH = localStorage.getItem('offer_zh') === 'zh'
i18nHelper.loadLanguagePack(4159)
i18nHelper.setFixedLocale(localStorage.getItem('offer_zh'))
this.$forceUpdate()
this.getCountry()
if (!this.code || !this.id) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}

PreEntryApi.checkLogin(
{ id: this.id, code: this.code },

(data, meta) => {
if (data && data.isSubmit === true) {
this.$router.push({ name: 'onboard.preview', query: { id: this.id } })

}
},
err => {
this.showLoading = false
if (err === -2) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}

},
() => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false

},
() => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
)

try {

PreEntryApi.getSchool({ name: '' }, (data, meta) => {
let res = []
if (data) {
data.forEach(function (item) {
res.push({
title: item.name,
other: item.id
})
})


if (val) {
res.unshift({

title: val,
other: -1
})
}
this.results = res
}
})

PreEntryApi.getExperience(
{ id: this.id, getField: 'study_experience', code: this.code },

(data, meta) => {
if (data) {
this.eduList = data
} else {
this.addEdu()
}
this.showLoading = false

},
code => {
if (code === -1) {
this.addEdu()
}
this.showLoading = false
},

err => {
this.showLoading = false
this.$message.error(this.$tsg('数据获取失败。'))
},

err => {
this.showLoading = false
this.$message.error(this.$tsg('系统内部错误，请联系管理员。'))
}
)


PreEntryApi.getStaffDetail({ id: this.id, code: this.code }, (data, meta) => {
if (data) {
if (data.birthday) {
var birthdayArr = data.birthday.split('-')
if (birthdayArr[0]) {
this.minFirstWorkDate.date = parseInt(birthdayArr[0]) + 10
}
}
this.country_id = data.country_id
this.degree_index = data.degree_index
}
})
} catch (e) {
this.showLoading = false
this.$message.error(this.$tsg('系统内部错误，请联系管理员。'))
}
},
mounted () {
i18nHelper.loadLanguagePack(4159)
},
methods: {
isLowEdu (edu) {
const low = [6, 10, 11] 
const n = Number(edu)
return low.includes(n)
},
changeEndDate (startDate, endDate) {
if (startDate !== null && endDate !== null) {
if (endDate < startDate) {
this.$message.error(this.$tsg('毕业年月必须大于等于开始年月'))
}
}
},
changeEducation (index) {

const edu = this.eduList[index].education
if (this.isLowEdu(edu)) {
this.eduList[index].major = this.$tsg('无')
} else {
this.eduList[index].major = ''
}
},
resultCountryClick (item) {
this.eduList[this.currentIndex]['school_country'] = item.title
},
getCountry () {
PreEntryApi.getAreaByName(
{ levelType: 'country' },
(data, meta) => {
if (data) {
this.areaItems = data[0]

var areaChangeItems = []
var areaChangeItemsEn = []
this.areaItems.forEach(function (item) {
areaChangeItems.push({
title: item.name,
other: item.id
})
areaChangeItemsEn.push({
title: item.en_name,
other: item.id
})
})

this.areaChangeItems = areaChangeItems
this.areaChangeItemsEn = areaChangeItemsEn
}
}
)
},
getCountryResult (val) {
val = val.replace(/^\s*|\s*$/g, '')
var areaChangeItems = []
var areaChangeItemsEn = []
if (this.areaItems && !val) {
this.areaItems.forEach(function (item) {
areaChangeItems.push({
title: item.name,
other: item.id
})
areaChangeItemsEn.push({
title: item.en_name,
other: item.id
})
})

this.areaChangeItems = areaChangeItems
this.areaChangeItemsEn = areaChangeItemsEn
return false
}

var res = [],
isComprise = false
this.areaChangeItems.forEach(function (item) {
if (item.title !== null && item.title.indexOf(val) !== -1) {
isComprise = true
res.push({
title: item.title,
other: item.other
/*
country_no: item.code_no,
*/
})
}
})

if (val && !isComprise) {
res.unshift({ title: val, other: -1 })
}

this.areaChangeItems = res
},
isMobile () {
if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
return true
}
return false
},
showStep () {
this.hasShowPopup.data = !this.hasShowPopup.data
},
getIndex ($event, index) {
this.currentIndex = index
this.$refs['search_' + index][0].onComposition($event, 'input')
},
getAreaIndex ($event, index) {
this.currentIndex = index
this.$refs['search_school_country' + index][0].onComposition($event, 'input')
},
changeIsfirst (index, evalue) {
if (evalue === 1) {
for (let i in this.eduList) {
if (parseInt(i) !== index) {
this.eduList[i].isfirst = 2
}
}
}
},
resultClick (item) {
this.eduList[this.currentIndex]['school'] = item.title
},
resultAreaClick (item) {
let that = this
that.eduList[that.currentIndex]['school_country'] = ''
this.areaItems.forEach(function (data) {
if (item.title === data.name) {
that.eduList[that.currentIndex]['school_country'] = item.title
}
})
},
getAreaResult (val) {

this.getCountryResult(val)
},

getResult (val) {

PreEntryApi.getSchool({ name: val }, (data, meta) => {
let res = []
if (data) {
data.forEach(function (item) {
res.push({
title: item.name,
other: item.id
})
})
if (val) {
res.unshift({
title: val,
other: -1
})
}
this.results = res
}
})
},
deleteRows (key) {
this.deleteRowsConfirm = true
this.deleteCurIndex = key
},
sendDel () {
this.eduList.splice(this.deleteCurIndex, 1)
this.sendedu(3)
},

getIsZh (data) {
var localStorage = window.localStorage
if (data) {
localStorage.setItem('offer_zh', 'zh')

} else {
localStorage.setItem('offer_zh', 'en')

}
this.isZH = data
},
addEdu () {
if (this.eduList.length === 5) {
this.$message.error(this.$tsg('教育经历填写最近的5个即可。'))
return false
}

this.eduList.push({
start_date: '',
end_date: '',
school: '',
major: '',
education: '',
degree: '',
study_style: '',
school_country: ''
})
},
sendedu (returnFlag) {
if (!this.id) {
this.$message.error(this.$tsg('非法操作。'))
return false
}
var temporarySchoolCountryJudge = true
if (this.eduList[this.currentIndex]) {
var temporarySchoolCountry = this.eduList[this.currentIndex]['school_country']
this.areaItems.forEach(function (data) {
if (temporarySchoolCountry === data.name) {
temporarySchoolCountryJudge = false
}
})
if (temporarySchoolCountryJudge) {
this.eduList[this.currentIndex]['school_country'] = ''
}
}

var eduList = []
let highestDegree = 99
for (let i in this.eduList) {
let item = this.eduList[i]

if (!this.isLowEdu(item.education) && !item.major) {
this.$message.error(this.$tsg('专业不能为空'))
return false
}

if (
item.degree || item.education || item.major || item.study_style ||
item.school || item.start_date || item.end_date || item.school_country
) {
if (item.start_date !== null && item.end_date !== null) {
if (item.end_date < item.start_date) {
this.$message.error(this.$tsg('毕业年月必须大于等于开始年月'))
return false
}
}
if (item.education < highestDegree) {
highestDegree = item.education
}
eduList.push(item)
}
}
if (parseInt(highestDegree) !== this.degree_index) {
console.log('学历', highestDegree, this.degree_index)


}

PreEntryApi.saveExperience(
{
id: this.id,
code: this.code,
study_experience: eduList,
saveField: 'study_experience'

},
data => {
if (data !== '') {
this.$message.error(this.$tsg('资料信息更新失败。'))
return false
}

if (returnFlag === 2) {
this.$router.push({ name: 'onboard.family', query: { id: this.id } })
} else if (returnFlag === 1) {
this.$router.push({ name: 'onboard.list', query: { id: this.id } })
} else if (returnFlag === 3) {

}

},
() => {
this.$message.error(this.$tsg('资料信息更新失败。'))
this.showLoading = false
}
)
},
postPsOption () {
PreEntryApi.postPsOption(
{},
(data, meta) => {

const degreeTypeObj = data['8'] || {}
this.educationItems = Object.keys(degreeTypeObj).map(key => ({
key: Number(key),
value: degreeTypeObj[key]
}))

const studyTypeObj = data['9'] || {}
this.studyStyleItems = Object.keys(studyTypeObj).map(key => ({
key: Number(key),
value: studyTypeObj[key]
}))

const dgTypeObj = data['14'] || {}
this.degreeItems = Object.keys(dgTypeObj).map(key => ({
key: Number(key),
value: dgTypeObj[key]
}))

this.showLoading = false
},
err => {
this.$message.error(this.$tsg('选项数据获取失败。'))
this.showLoading = false
}
)
}
}
}



// WEBPACK FOOTER //
// ./src/components/onboard/edu.vue